<template>
    <div class="flex items-start" @click="toggle">
        <div>
            <inline-svg v-if="checkedInternal" class="icon checkbox-icon" src="/img/icons/icon-radio-active.svg" />
            <inline-svg v-else class="icon checkbox-icon" src="/img/icons/icon-radio.svg" />
        </div>
        <div :class="this.labelClass">{{ this.label }}</div>
    </div>
</template>

<script>
    export default {
        name: "ria-checkbox",
        props: {
            fontSize: String,
            value: Boolean,
            label: String,
            required: Boolean
        },
        data() {
            return {
                checkedInternal: this.value,
                labelClass: `text text-${this.fontSize}`,
            };
        },
        methods: {
            toggle() {
                this.checkedInternal = !this.checkedInternal
                this.$emit('changed', {status: this.checkedInternal})
            },

            enabled() {
                return this.checkedInternal
            },

            isValid() {
                return !this.required || (this.required && this.checkedInternal)
            }
        },
    };
</script>

<style scoped>
    .checkbox-icon {
       @apply mr-3
    }
</style>

